// Tarjetas formateadas con SecureGate (design/SECURE-CARD.md): lo que el panel muestra en Cuenta -> Seguridad.
// El panel solo GESTIONA (listar, renombrar, revocar, login por UID): formatear necesita acceso en bruto al chip
// (paginas / ISO-DEP) y eso solo lo tiene la app de Android.

/** Etiqueta del chip tal como lo nombra la documentacion (no se traduce: son nombres de producto). */
export function chipLabel(chipType) {
  if (chipType === 'ntag424') return 'NTAG 424 DNA';
  if (chipType === 'ntag21x') return 'NTAG 215/216';
  return chipType || '';
}

/**
 * Estado a mostrar: 'active' | 'pending' (formateo a medias) | 'revoked' | 'revokedCopy' (revocada por posible copia).
 * Clave i18n: account.security.cards.status.<estado>.
 */
export function cardStatus(card) {
  if (card?.status === 'revoked') return card.revokedReason === 'clone_suspected' ? 'revokedCopy' : 'revoked';
  if (card?.status === 'pending') return 'pending';
  return 'active';
}

/** Solo se renombra o revoca lo que no esta revocado. */
export function canManage(card) {
  return card?.status !== 'revoked';
}

/**
 * Estado del interruptor «Iniciar sesion con el numero de la tarjeta (UID)».
 *  - checked: el UID puede abrir la cuenta (con PIN, como siempre).
 *  - canTurnOff: el servidor exige al menos una tarjeta segura activa para apagarlo (409 secure_card_required).
 *  - needsFactor: encenderlo baja la seguridad y el servidor pide PIN o contrasena maestra otra vez.
 *  - visible: sin tarjetas formateadas y con el UID encendido no hay nada que decidir (se muestra el aviso de formatear).
 */
export function uidSwitchState({ uidLoginDisabled, cards }) {
  const activeCount = (cards || []).filter((c) => c.status === 'active').length;
  const checked = !uidLoginDisabled;
  return {
    checked,
    activeCount,
    canTurnOff: activeCount > 0,
    needsFactor: !checked,
    visible: activeCount > 0 || !checked,
  };
}

/** Cuerpo de `PUT /account/security/uid-login`. Apagar no lleva factor; encender, PIN o contrasena maestra. */
export function uidLoginBody(enabled, { method, pin, masterPassword } = {}) {
  if (!enabled) return { enabled: false };
  return method === 'master_password' ? { enabled: true, masterPassword } : { enabled: true, pin };
}

/**
 * Traduce el fallo de un cambio del login por UID. Devuelve { key, vars } de i18n o null si no es un caso conocido
 * (el llamador cae a apiErrorMessage). El servidor responde 403 (nunca 401: el panel cierra sesion con un 401).
 */
export function uidLoginErrorKey(data) {
  switch (data?.code) {
    case 'second_factor_invalid':
      return { key: 'loginV2.secondFactorInvalid', vars: { count: data.remaining ?? 0 } };
    case 'too_many_attempts':
      return { key: 'account.danger.errTooMany', vars: { minutes: Math.max(1, Math.ceil((data.retryAfter || 60) / 60)) } };
    default:
      return null;
  }
}
